import PageLoad from "./pageLoad";

export default PageLoad;